import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import TenantActions from '@Actions/tenantActions';
import UnicommerceIntegrationActions from '@Actions/integrations/unicommerceIntegrationActions';
import {
  Button,
  Select,
  notification
} from 'antd';
import TenantSelector from '@Components/Common/Selector/TenantSelector';
import SelectSkuList from '@Components/Common/Selector/SelectSkuList';
import ScheduledReport from '../../../../../../../ReportsV2/ScheduledReport';
import H3Text from '@Uilib/h3Text';
import Helpers from '@Apis/helpers';
import './style.scss';
import '../../../../../../../../scss/integration.scss'
import PRZSelect from '../../../../../../../Common/UI/PRZSelect';

const { Option } = Select;

const SchduleCronForm = ({
  user, scheduleUcSyncLoading, scheduleUcSync, callback,
}) => {
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [selectedTenant, setSelectedTenant] = useState('');
  const [selectedList, setSelectedList] = useState(null);
  const [scheduledJobs, setScheduledJobs] = useState([]);
  const [toRecipients, setToRecipients] = useState([]);
  const [inventoryTypes, setInventoryTypes] = useState(['BAD_INVENTORY', 'GOOD_INVENTORY']);
  const [schedule, setSchedule] = useState('')


  const isScheduleValid = () => {
    if(schedule?.selectedFrequency === 'DAILY' && !schedule?.selectedTime) return false;
    if(schedule?.selectedFrequency === 'WEEKLY' && !schedule?.selectedTime && !schedule?.selectedDays.length) return false;
    if(schedule?.selectedFrequency === 'MONTHLY' && !schedule?.selectedTime && !schedule?.selectedDate) return false;
    return true;
  }
  const isFormValid = () => {
    if(!selectedTenant || !selectedList || !inventoryTypes?.length || !toRecipients?.length) return false;
    return true;
  }
  const handleSubmit = () => {
    setFormSubmitted(true);
    if(isFormValid() && isScheduleValid()) {
      const payload = {
        tenant_id: selectedTenant,
        sku_list_id: selectedList,
        schedule_configurations: {
          "time": schedule?.selectedTime,
          "type": schedule?.selectedFrequency,
          "specific_date": schedule?.selectedDate,
          "days": schedule?.selectedDays,
          "date": schedule?.selectedDate ? schedule?.selectedFrequency === 'MONTHLY' ? schedule?.selectedDate.date() : dayjs(schedule?.selectedDate).format('DD-MM-YYYY') : null,
        },
        job_name: "UNICOMMERCE_PUSH_INVENTORY",
        inventory_types : inventoryTypes,
        recipients: toRecipients
    };
      scheduleUcSync(payload, () => {
        setFormSubmitted(false);
        if(callback) {
          callback();
        }
      })
    } else {
      notification.open({
        type: 'error',
        message: 'Please enter all manadtory inputs',
        duration: 4,
        placement: 'top',
      })
    }

  };

  const inventoryConditionOptions = [
    { label: 'Good', value: 'GOOD_INVENTORY' },
    { label: 'Bad', value: 'BAD_INVENTORY' },
  ];

  return (
    <div className="integration-cron__wrapper">
      <div className="integration-cron__input-wrapper">
        <H3Text text="Select Business Unit" className="integration-cron__input-label" />
        <TenantSelector
          selectedTenant={selectedTenant}
          noDropdownAlign
          showSearch
          hideTitle
          onChange={(value) => setSelectedTenant(value)}
          placeholder="Select Business Unit"
        />
        {formSubmitted && !selectedTenant && <H3Text text="Please select a business unit" className="input-error" />}
      </div>
      <div className="integration-cron__input-wrapper">
        <H3Text text="Product Group to be Synced" className="integration-cron__input-label" />
        <SelectSkuList
          selectedList={selectedList}
          noDropdownAlign
          showSearch
          hideTitle
          customStyle={{
            borderRadius: '2px',
            height: '28px',
            width: '100%',
            fontSize: '13px',
          }}
          selectedTenant={selectedTenant}
          onChange={(value) => setSelectedList(value)}
          placeholder="Select Product List"
          disabled={!selectedTenant}
        />
        {formSubmitted && !selectedList && <H3Text text="Please select a product group" className="input-error" />}
      </div>
      <div className="integration-cron__input-wrapper">
        <H3Text text="Inventory Type to be Synced" className="integration-cron__input-label" />
        <PRZSelect
          value={inventoryTypes}
          filterOption={false}
          placeholder="Select inventory types"
          onChange={(value) => { setSelectedTenantIds(value); }}
          bordered
          showSearch
          className="integration-step-input__input"
          mode="multiple"
          options={inventoryConditionOptions}
          showError={formSubmitted && !inventoryTypes?.length}
          errorName="Please select inventory types"
          errorClassName="input-error"
        />
      </div>
      <div className="integration-cron__input-wrapper">
        <H3Text text="Recipients for Sync Failure Alerts" className="integration-cron__input-label" />
        <PRZSelect
          className="integration-step-input__input"
          mode="tags"
          value={toRecipients}
          maxTagCount="responsive"
          onChange={(value) => {
            const recipients = [];
            for (let i = 0; i < value?.length; i++) {
              if (Helpers.validateEmail(value[i])) {
                recipients.push(value[i]);
              }
            }
            setToRecipients(recipients)
          }}
          showError={formSubmitted && !toRecipients?.length}
          errorName=" at least one recipient"
          errorClassName="input-error"
        />
      </div>

      <div className="integration-cron__input-wrapper">
        <ScheduledReport
          allowedDurations={['DAILY', 'HOURLY', 'WEEKLY', 'MONTHLY']}
          setScheduledReportData={setSchedule}
          alwaysOn
          disabled={!selectedList}
        />
        {formSubmitted && !isScheduleValid() && <H3Text text="Please select a valid schedule" className="input-error" />}
      </div>
      <div className="custom-drawer__footer">
          <Button
            type="primary"
            onClick={() => handleSubmit()}
            loading={scheduleUcSyncLoading}
            disabled={scheduleUcSyncLoading}
          >
            Create Scheduled Sync
          </Button>
      </div>
    </div>
  );
};

const mapStateToProps = ({ UserReducers, UnicommerceIntegrationReducers }) => ({
  user: UserReducers.user,

  scheduleUcSyncLoading: UnicommerceIntegrationReducers.scheduleUcSyncLoading,
});

const mapDispatchToProps = (/* Import actions here */ dispatch) => ({
  getTenants: (page, keyword, isVerified, orgId) => dispatch(TenantActions.getTenants(page, keyword, isVerified, orgId)),
  scheduleUcSync: (payload, callback) => dispatch(UnicommerceIntegrationActions.scheduleUcSync(payload, callback)),
});

SchduleCronForm.propTypes = {
  user: PropTypes.any,
  setStep: PropTypes.func,
  updateUnicommerceConfiguration: PropTypes.func,
  updateUnicommerceConfigurationLoading: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SchduleCronForm));
